import { render, staticRenderFns } from "./SmsTextBoxFooter.vue?vue&type=template&id=1fb157bc&scoped=true"
import script from "./SmsTextBoxFooter.vue?vue&type=script&lang=js"
export * from "./SmsTextBoxFooter.vue?vue&type=script&lang=js"
import style0 from "./SmsTextBoxFooter.vue?vue&type=style&index=0&id=1fb157bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb157bc",
  null
  
)

export default component.exports